import React from 'react';
import style from './style.css';

const Heading = ({ text }) => {
    return <h1 className={`${style.heading} ${style.h1}`}>{text}</h1>;
};

export default Heading;
